import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPatients } from '../../../store/slices/patientsSlice';
import { createNursingOPDAssessment } from '../../../store/slices/nursingOPDAssessmentsSlice';
import MainLayout from '../../../components/layout/MainLayout';
import Breadcrumbs from '../../../components/common/Breadcrumbs';
import NursingOPDAssessmentForm from './NursingOPDAssessmentForm';
import InlinePatientForm from '../../Patient/InlinePatientForm';
import Swal from 'sweetalert2';
import { getApiErrorMessage } from "../../../utils/apiError";

const AddNursingOPDAssessment = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [initialPatientId, setInitialPatientId] = useState(null);
    const { patients, isLoading: isPatientsLoading } = useSelector((state) => state.patients);

    useEffect(() => {
        dispatch(fetchPatients());
    }, [dispatch]);

    const handlePatientCreated = (newPatient) => {
        if (newPatient && newPatient.id) {
            setInitialPatientId(newPatient.id);
        }
    };

    const handleFormSubmit = async (formData) => {
        setIsLoading(true);
        try {
            await dispatch(createNursingOPDAssessment(formData)).unwrap();

            Swal.fire({
                title: 'Success!',
                text: 'Nursing Assessment added successfully!',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false,
                position: 'top',
                width: '300px',
            }).then(() => {
                navigate('/nursing-opd-assessments');
            });
        } catch (error) {
            console.error('Error adding assessment:', error);
            Swal.fire({
                title: 'Error!',
                text: typeof error === 'string' ? error : (getApiErrorMessage(error, 'Failed to add assessment.')),
                icon: 'error',
                confirmButtonText: 'OK',
                position: 'top',
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                {/* Patient Creation Accordion */}
                <div className="accordion mb-4 mt-2" id="patientCreationAccordion">
                    <div className="accordion-item shadow-sm rounded border-primary" style={{ borderLeft: "4px solid #696cff" }}>
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold text-primary" type="button" data-bs-toggle="collapse" data-bs-target="#createPatientPanel">
                                <i className="ri-user-add-line me-2"></i> Create New Patient First
                            </button>
                        </h2>
                        <div id="createPatientPanel" className="accordion-collapse collapse show" data-bs-parent="#patientCreationAccordion">
                            <div className="accordion-body pt-3">
                                <InlinePatientForm 
                                    onSuccess={(newPatient) => {
                                        handlePatientCreated(newPatient);
                                        const btn = document.querySelector('[data-bs-target="#createPatientPanel"]');
                                        if (btn) btn.click();
                                    }} 
                                    onCancel={() => {
                                        const btn = document.querySelector('[data-bs-target="#createPatientPanel"]');
                                        if (btn && !btn.classList.contains('collapsed')) btn.click();
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card mb-4 mt-2">
                    <div className="card-body">
                        <NursingOPDAssessmentForm
                            onSubmit={handleFormSubmit}
                            isLoading={isLoading || isPatientsLoading}
                            buttonText="Create Assessment"
                            patients={patients}
                            initialPatientId={initialPatientId}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AddNursingOPDAssessment;
